<template>
    <div class="cx_label" :style="{'font-size':fontSize + 'px'}">
        <span :style="{'font-weight':fontWeight}">{{text}}</span><i  v-if="tooltip" class="material-icons small valign help" ref="tooltip_target">help_outline</i><slot></slot>
    </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class Label extends Vue {
  @Prop({default:''}) public text: string;
  @Prop({default:16}) public fontSize:number;  
  @Prop({default:600}) public fontWeight:number;      
  @Prop({default:null}) public tooltip: string;  
  public mounted() {
    if(this.tooltip) this.$nextTick(()=>this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip));
  }  
}

</script>
<style lang="scss">
  .cx_label{
      margin-bottom:20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;      
      span {
          font-weight: 600;
          text-align: left;
        //   text-decoration: underline;
      }

    i.small {
      margin-left:2px;
      margin-bottom:3px;
      margin-right:0px;
      font-size: 15px;
      color:#9e9d9d;      

      &.help:hover{
        color:#007bff;                
        cursor:pointer;
      }   
    }
  }
</style>